import { getFarmsPriceHelperLpFiles } from '@pancakeswap/farms'
import { ChainId } from '@pancakeswap/sdk'
import PoolsBitgertPriceHelper from './pools/766'
import PoolsCorePriceHelper from './pools/7668378'

export { getFarmsPriceHelperLpFiles }

export const getPoolsPriceHelperLpFiles = (chainId: ChainId) => {
  switch (chainId) {
    case ChainId.QOM:
      return PoolsBitgertPriceHelper
    case ChainId.TQOM:
      return PoolsCorePriceHelper
    default:
      return []
  }
}
